import React from 'react';
import {IEvent, IBoardEvent} from "../../ModelContracts";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import {Link} from "react-router-dom";

dayjs.extend(advancedFormat);

interface IProps {
	event: IEvent,
	maxLength?: number
}

function EventCard({event, maxLength}: IProps) {
	function isBoardEvent(e: IEvent): e is IBoardEvent {
		return 'boardId' in e;
	}

	const getLinkPath = () => {
		if (isBoardEvent(event)) return `/boards/${event.boardId}`;
		return '#';
	};

	const truncated = maxLength && event.description.length > maxLength;
	const displayText = truncated
		? event.description.substring(0, maxLength).trimEnd() + '...'
		: event.description;

	return (
		<Link className="no-underline" to={getLinkPath()}>
			<div className="card card-compact bg-base-200 shadow-sm hover:shadow-md transition-shadow" title={truncated ? event.description : undefined} aria-label="Event">
				<div className="card-body relative">
					<div className="flex justify-between items-start">
						<p className="text-sm">{displayText}</p>
					</div>
					<div className="card-actions justify-between">
						<span className="badge badge-accent badge-sm">{event.eventType}</span>
						<span className="badge badge-primary badge-sm">{dayjs(event.date).format('Do MMM YY')}</span>
					</div>
				</div>
			</div>
		</Link>
	);
}

export default EventCard;
